export default {
    workers: [],
}